// var md5 = require('./md5.min.js');
// import A from './md5.min.js'

import axios from 'axios'
var base = require('./base64.js')

// const getBase64 = data => {
//   return base.BASE64.encode(base.utf16to8(data))
// }

export default {
  install (Vue, options) {
    Vue.prototype.Request = function (obj) {
      var timestamp = Math.round(new Date().getTime() / 1000)
      var randomNumber = Math.floor(Math.random() * 1000)
      // const appId = 'wxd85b5d6d51e9b804';
      // const appSecret ='88d772e85a86902d09a9be6380a81177';
      // var timestamp = 1;
      // var randomNumber = 1;
      const appSecret = '65537'
      const appId = '1'
      var token = appId + timestamp + randomNumber + JSON.stringify(obj.data) + appSecret
      // token = md5.md5(token);
      token = base.md5(token)
      token = token.toUpperCase()

      // var url = 'https://self.estar-info.com/server/claimDataController.do?';
      // 开发环境
      // var url = '/server/';
      var url = ''

      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
      axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'X-Requested-With,Content-Type'
      axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS'

      // axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? url : 'https://ebusiness.china-ric.com/api/server/';
      axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? url : 'http://wxtest.cic.cn/'
      // axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? url : 'http://localhost:8080/server/';
      // axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      axios.defaults.headers.post['Authorization'] = 'your token'
      axios.defaults.headers.post['version'] = '2'
      axios.defaults.headers.post['randomNumber'] = randomNumber
      axios.defaults.headers.post['timestamp'] = timestamp
      axios.defaults.headers.post['appId'] = appId
      axios.defaults.headers.post['token'] = token
      axios.defaults.headers.post['referer'] = 'http://wtest.cic.cn/CICWechat/test.html'

      axios({
        // url: url + obj.url,
        // url: "claimDataController.do?" + obj.url,
        url: obj.url,
        method: 'POST',
        // header: {
        //     "Authorization": "your token",
        //     // "Content-Type": "application/json;charset=utf-8",
        //     // "content-type": "application/json",
        //     // "User-Agent": "imgfornote",
        //     "version": "2",
        //     "randomNumber": randomNumber,
        //     "timestamp": timestamp,
        //     "appId": appId,
        //     "token": token
        // },
        // data: getBase64(JSON.stringify(obj.data)),
        data: obj.data
        // success: function(res) {
        //     obj.success(res);
        // },
        // fail: function (res) {
        //     console.log(res);
        // }
      }).then(function (res) {
        obj.success(res.data)
      }).catch(function (res) {
        obj.fail(res)
      })
    }
    Vue.prototype.ShowToast = function () {
      alert('loading...')
    }
    Vue.prototype.HideToast = function () {
      alert('loading...')
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js